/** Section chrome aligned with `PropertyEdit` (border-b title + left rule on fields). */
export const EMAIL_TEMPLATE_SECTION_TITLE_CLASS =
  'text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-slate-800 border-b border-slate-200 pb-2'

export const EMAIL_TEMPLATE_SECTION_BODY_CLASS =
  'w-full min-w-0 space-y-4 pl-3 sm:pl-4 border-l-2 border-slate-100 ml-0.5 sm:ml-1'

export const wfBlock = (wt: string | undefined, ...keys: string[]): boolean => {
  if (!wt) return false
  return keys.includes(wt)
}
